import React from "react";
import container from "../../../../styles/Global.module.css";
import {
  compaoBrandsStatus,
  compaoNetwork,
} from "../../../../json/StatusOptions.js";
import ColumnStatus from "../../../../components/global/fields/ColumnStatus.jsx";
import EditableText from "../../../../components/global/fields/EditableText.jsx";
import SingleDuration from "../../../../components/global/fields/SingleDurationDatePicker.jsx";
import BaseBoard from "../../../global/BoardTemplate/BaseBoard.jsx";
import { GridLogicOperator } from "@mui/x-data-grid-pro";
import EditableSelect from "../../../../components/global/fields/EditableSelect.jsx";
import { useCustomState } from "../../../../utils/useCustomState.js";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const CompaoBrands = () => {
  const apiUrl = `${backendUrl}/api/compao-brand/items`;

  const [state, updateState] = useCustomState({
    status: "Compao Marcas",
    groups: ["Compao Marcas"],
    users: [],
    categories: [],
    refreshState: false,
    items: [],
    selectionRow: [],
    updateRows: [],
    investByMonth: "",
    columnsFilter: { id: false },
    viewFilter: {
      items: [],
      quickFilterLogicOperator: GridLogicOperator.Or,
    },
    pinnedColumns: {
      left: ["__check__", "threads"],
      right: [],
    },
  });

  const filterItemsAndSetGroups = (items) => {
    updateState({ items });
  };

  const handleEditResponseChange = async (newValue, rowID, field) => {
    const updatedRowsNoTerminados = state.items.map((row) => {
      if (+row.id === +rowID) {
        return { ...row, [`${field}`]: newValue };
      }
      return row;
    });

    updateState({ items: updatedRowsNoTerminados });
  };

  const getGroupRows = (groupName) => {
    return groupName === "Compao Marcas" ? state.items : [];
  };

  const updateBoard = (newData) => {
    const updatedRows = [...state.updateRows, newData];

    updateState({ updateRows: updatedRows });
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      headerAlign: "center",
      align: "center",
    },
    // {
    //   field: "threads",
    //   headerName: "Thread",
    //   width: 70,
    //   headerAlign: "center",
    //   align: "center",

    //   renderCell: (params) => {
    //     return <ThreadListModal {...params} />;
    //   },
    // },
    {
      field: "brand",
      headerName: "Marca",
      width: 250,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"brand"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.brand}
        />
      ),
    },
    {
      field: "network",
      headerName: "Network",
      width: 160,
      align: "center",

      headerAlign: "center",
      renderCell: (params) => (
        <EditableSelect
          {...params}
          field={"network"}
          handleEditResponseChange={handleEditResponseChange}
          options={compaoNetwork}
          spanText={params.row.network}
          initialValue={params.row.network}
          label="Network"
        />
      ),
    },
    {
      field: "date",
      headerName: "Fecha de alta",
      width: 160,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <SingleDuration
          {...params}
          selectionRow={state.selectionRow}
          fieldKey="date"
        />
      ),
    },
    {
      field: "brandWebsite",
      headerName: "Sitio web de la marca",
      width: 250,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"brandWebsite"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.brandWebsite}
        />
      ),
    },
    {
      field: "trackingLink",
      headerName: "Tracking link",
      width: 250,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"trackingLink"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.trackingLink}
        />
      ),
    },
    {
      field: "status",
      headerName: "GTM / GA4",
      width: 160,
      cellClassName: "no-padding",
      headerAlign: "center",

      renderCell: (params) => (
        <ColumnStatus
          {...params}
          selectionRow={state.selectionRow}
          field={"status"}
          columnPosition={280}
          handleEditResponseChange={handleEditResponseChange}
          statusOption={compaoBrandsStatus}
        />
      ),
    },
    {
      field: "eventName",
      headerName: "Event name",
      width: 250,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <EditableText
          {...params}
          field={"eventName"}
          handleEditResponseChange={handleEditResponseChange}
          initialValue={params.row.eventName}
        />
      ),
    },
  ];

  return (
    <div className={container.globalContainer}>
      <BaseBoard
        columns={columns}
        groups={state.groups}
        getGroupRows={getGroupRows}
        setGroupItems={filterItemsAndSetGroups}
        apiUrl={apiUrl}
        status={state.status}
        setStatus={(status) => updateState({ status })}
        updateBoard={updateBoard}
        updateRows={state.updateRows}
        setSelectionRow={(selectionRow) => updateState({ selectionRow })}
        selectionRow={state.selectionRow}
        setViewFilter={(viewFilter) => updateState({ viewFilter })}
        viewFilter={state.viewFilter}
        columnsFilter={state.columnsFilter}
        setColumnsFilter={(columnsFilter) => updateState({ columnsFilter })}
        pinnedColumns={state.pinnedColumns}
        setPinnedColumns={(pinnedColumns) => updateState({ pinnedColumns })}
        checkboxSelection={true}
        refreshState={state.refreshState}
        height={"80vh"}
        maxHeight={"80vh"}
      />
    </div>
  );
};

export default CompaoBrands;
